"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useProxyTrigger = void 0;
var _react = require("react");
/**
 * The purpose of this hook is to call onTrigger callback on data object property call.
 * That can help in case when you don't want data to be fetched from a server unless component
 * calls a property of a data object.
 *
 * Example case:
 * You have 2 components which use 1 set of data. You move fetch hook of this data set to a common
 * context (App context etc.). Obviously, you don't need that data to be loaded in all components
 * except of those 2. In such case this hook is useful. Your code would look like this:
 *
 * const [isTriggered, setIsTriggered] = useState(false);
 * const onTrigger = useCallback(() => setIsTriggered(true), [setIsTriggered]);
 * const { data } = useFetch(url, initialValue, isTriggered);
 * const proxyData = useProxyTrigger(data, onTrigger, !isTriggered);
 */
var useProxyTrigger = function useProxyTrigger() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var onTrigger = arguments.length > 1 ? arguments[1] : undefined;
  var isActive = arguments.length > 2 ? arguments[2] : undefined;
  return (0, _react.useMemo)(function () {
    if (isActive) {
      return new Proxy({
        data: data
      }, {
        get: function get(target, prop) {
          onTrigger(prop);
          try {
            return Reflect.get(target.data, prop);
          } catch (_unused) {
            return undefined;
          }
        }
      });
    }
    return data;
  }, [data, isActive, onTrigger]);
};
exports.useProxyTrigger = useProxyTrigger;